var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value}},[_c('el-option',{attrs:{"label":"Español","value":"es"}}),_c('el-option',{attrs:{"label":"English","value":"en"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }